module.exports = __webpack_public_path__ + "static/media/GREY.b2f5b3a6.svg";